import { render, staticRenderFns } from "./companyCard.vue?vue&type=template&id=90daf94c&scoped=true"
import script from "./companyCard.vue?vue&type=script&lang=js"
export * from "./companyCard.vue?vue&type=script&lang=js"
import style0 from "./companyCard.vue?vue&type=style&index=0&id=90daf94c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90daf94c",
  null
  
)

export default component.exports